module.exports = __webpack_public_path__ + "static/media/Delete.41c8548e.png";